import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicIconDirective } from './dynicon.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicIconDirective],
  exports: [DynamicIconDirective],
})
export class DynamicIconDirectiveModule {}
